import {
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { BaseDropdownComponent } from '../_base-dropdown.component';


@Component({
  moduleId: module.id,
  selector: 'plus-dropdown',
  templateUrl: 'plus-dropdown.component.html',
  styleUrls: ['plus-dropdown.component.scss'],
})
export class PlusDropdownComponent extends BaseDropdownComponent {
  @Input() inverted: boolean = false;

  @Input() buttonStyle: string = '';
  @Input() alignmentRight: boolean = false;

}
